export const BoxContainer = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px",
  };

  export const BoxIconStyle = {
    display: "flex",
    alignItems: "Center",
    columnGap: "20px",
  };


  export const StyleForPersonIcon = {
              backgroundColor: "white",
            "&:hover": {
              backgroundColor: "green",
              color: "whitesmoke",
   }
}

export const StyleForNightModeIcon ={
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "black",
      color: "whitesmoke",
}}

export const StyleForNotifIcon ={
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#dc5159",
      color: "whitesmoke",
}}


